module.exports = __webpack_public_path__ + "kaitak_FV_20210730.8e13cdc075d36c8bb623.png";